import type { IconProps } from '../types/IconProps.ts';
export const CircleArrowLeft: IconProps = {
    name: 'CircleArrowLeft',
    children: [
        `<path d="m12 8-3.91 3.8a.3.3 0 0 0 0 .4L12 16M9 12h7" />`,
        `<circle cx="12" cy="12" r="10" />`,
    ]
};